// extracted by mini-css-extract-plugin
export var callCard = "_s4-0";
export var callMessageButton = "_s4-1";
export var helpIcon = "_s4-3";
export var helpIconContainer = "_s4-4";
export var verticalDivider = "_s4-2";